export function responsibleListAllQuery(displayOnlyActives = false) {
  const query = `{responsibleListAll(displayOnlyActives: ${displayOnlyActives}) {id, fullName, cpf, gender, birthDate, cellPhone, cellPhoneAux, phone, email, responsibilities, lastAccessDate, lastAccessBy, lastAccessInMilli, engagementStatus}}`;
  return query;
}

export function responsibleFindByEmailQuery(email) {
  const query = `{
  responsibleFindByEmail(email: "${email}") {
    id
    email
    cpf
    rg
    firstName
    lastName
    fullName
    gender
    birthDate
    cellPhone
    cellPhoneAux
    phone
    zipCode
    address
    addressNumber
    addressAdjunct
    neighborhood
    city {
      id
      ibgeId
      name
      uf
      stateId
    }
    state {
      id
      name
      uf
    }
    fileId
    profilePhoto
  }
}`;
  return query;
}

export function responsibleSaveMutation(values, validateCpf) {
  let city = { ibgeId: 0, stateId: 0, id: 0 };
  if (values.city) {
    city = {
      ...values.city,
    };
    delete city.value;
    delete city.label;
  }

  let state = { id: 0 };
  if (values.state) {
    state = {
      ...values.state,
    };
    delete state.value;
    delete state.label;
  }

  let studentRelations = [];
  if (values.relatedStudents) {
    studentRelations = values.relatedStudents.map((item) => ({
      id: item.id,
      responsible: item.responsible,
      student: {
        ...item.student,
        legacyId: 0,
        dateOfBirth: 0,
        filterByStatus: false,
        updaterId: 0,
        active: true,
        activeOnLoggedPeriod: true,
      },
      type: item.type,
      accessStudentData: item.accessStudentData,
      takeStudent: item.takeStudent,
      financialContact: item.financialContact,
      firstContact: item.firstContact,
      emergencyContact: item.emergencyContact,
    }));
  }

  const mutationQuery = `mutation($firstName: String, $lastName: String, $fullName: String) {
                            responsibleSave(                              
                                  responsible: {id: ${values.id ? values.id : 0}
                                              , email: "${values.email}"
                                              , cpf: "${
                                                values.cpf ? values.cpf : ''
                                              }"
                                              , rg: "${
                                                values.rg ? values.rg : ''
                                              }"
                                              , firstName: $firstName,
                                              , lastName: $lastName,
                                              , fullName: $fullName,
                                              , gender: "${values.gender}"
                                              , birthDate: ${
                                                values.birthDate
                                                  ? values.birthDate.getTime()
                                                  : null
                                              }
                                              , cellPhone: "${
                                                values.cellPhone
                                                  ? values.cellPhone
                                                  : ''
                                              }"
                                              , cellPhoneAux: "${
                                                values.cellPhoneAux
                                                  ? values.cellPhoneAux
                                                  : ''
                                              }"
                                              , phone: "${
                                                values.phone ? values.phone : ''
                                              }"
                                              , zipCode: "${
                                                values.zipCode
                                                  ? values.zipCode
                                                  : ''
                                              }"
                                              , address: "${
                                                values.address
                                                  ? values.address
                                                  : ''
                                              }"
                                              , addressNumber: "${
                                                values.addressNumber
                                                  ? values.addressNumber
                                                  : ''
                                              }"
                                              , addressAdjunct: "${
                                                values.addressAdjunct
                                                  ? values.addressAdjunct
                                                  : ''
                                              }"
                                              , neighborhood: "${
                                                values.neighborhood
                                                  ? values.neighborhood
                                                  : ''
                                              }"
                                              , city: ${JSON.stringify(
                                                city
                                              ).replace(
                                                /"([^(")"]+)":/g,
                                                '$1:'
                                              )}
                                              , state: ${JSON.stringify(
                                                state
                                              ).replace(
                                                /"([^(")"]+)":/g,
                                                '$1:'
                                              )}
                                              , students: ${JSON.stringify(
                                                studentRelations
                                              ).replace(
                                                /"([^(")"]+)":/g,
                                                '$1:'
                                              )}
                                              , filterByStatus: false
                                              , updaterId: 0
                                              , validateCpfOnSubmit: ${validateCpf}
                                              , fileId: "${
                                                values.fileId
                                                  ? values.fileId
                                                  : ''
                                              }"
                                              , profilePhoto: "${
                                                values.profilePhoto
                                              }"
                                              , chatUserId: ${
                                                values.chatUserId
                                                  ? values.chatUserId
                                                  : 0
                                              } 

                                          }),
                              {id}
                          }`;
  return mutationQuery;
}
